import { render } from "./flash.vue?vue&type=template&id=5516080e&scoped=true"
import script from "./flash.vue?vue&type=script&lang=js"
export * from "./flash.vue?vue&type=script&lang=js"

import "./flash.vue?vue&type=style&index=0&id=5516080e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5516080e"]])

export default __exports__